<template>
    <div>
        <div class="search-bar row no-gutters">
            <div class="col p-0">
                <input
                    class="form-control-lg search py-0"
                    name="qCode"
                    v-model="qCode"
                    type="text"
                    :placeholder="placeholderCode"
                />
            </div>
            <div class="col p-0">
                <input
                    class="form-control-lg search py-0"
                    name="qTitle"
                    v-model="qTitle"
                    type="text"
                    :placeholder="placeholderTitle"
                />
            </div>
          <div class="col p-0">
                <core-drop-down
                  wrapperClass="form-control-lg"
                  :placeholder="$t('services.list.search.filter-by-country')"
                  :items="countries"
                  :selectedValue.sync="country"
                  v-model="country"
                  :valueAttribute="countryValueAttribute"
                  searchable
                ></core-drop-down>
            </div>
        </div>
        <div class="results-count pt-4 pl-3" v-show="total">
            <span id="resultsCountNumber">{{ total }}</span>
            <span id="resultsText"> {{ $tc('services.list.search.results', total) }}</span>
        </div>
        <search-list-service
            v-if="searchResults.length"
            :results="searchResults"
            :attributes="attributes"
        ></search-list-service>
        <core-pagination :page.sync="page" :pages.sync="pages" :pageSize.sync="pageSize" @update="getServices"></core-pagination>
    </div>
</template>

<script>
import Search from '@/services/hatsApi/Search'
import Geo from '@/services/hatsApi/Geo'

export default {
  data () {
    return {
      page: 1,
      pages: 1,
      pageSize: 10,
      // placeholderText: this.placeholder,
      qCode: '',
      qTitle: '',
      country: null,
      strl: 1,
      searchResults: [],
      total: null,
      itemLinkType: this.linkType,
      countries: []
    }
  },
  props: {
    placeholderCode: {
      default: 'Zoeken op code',
      type: String,
      required: false
    },
    placeholderTitle: {
      default: 'Zoeken op naam',
      type: String,
      required: false
    },
    attributes: {
      type: Array,
      required: false
    },
    serviceType: {
      default: null,
      type: Number,
      required: false
    }
  },
  computed: {
    countryValueAttribute () {
      console.log()
      return 'name_' + this.$i18n.locale.toUpperCase()
    }
  },
  watch: {
    // whenever q changes, this function will run
    qCode: function () {
      this.debouncedSearch()
    },
    qTitle: function () {
      this.debouncedSearch()
    },
    country: function () {
      this.getServices()
    }
  },
  created: function () {
    Geo.getCountries().then((response) => {
      this.countries = response.data.data
    })
    this.debouncedSearch = this.$_.debounce(this.getServices, 500)
    this.getServices()
  },
  methods: {
    async getServices () {
      let countryId = this.country !== null && this.country.hasOwnProperty('id') ? this.country.id : null
      try {
        const response = await Search.service(this.qCode, this.qTitle, countryId, this.strl, this.pageSize, this.page, this.serviceType)
        this.searchResults = response.data.data

        if (this.page !== 1 && response.data.data.length === 0) {
          this.page = 1
          this.getServices()
        } else {
          this.page = response.data.page
          this.pages = response.data.pages
          this.total = response.data.total
          this.searchResults = response.data.data
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/Service.vue